export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '海量热门国产剧、韩剧、美剧、日剧，每日更新',
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '最新院线大片、经典电影、高分佳作一网打尽',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '国漫崛起、日漫经典、热血冒险应有尽有',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺、真人秀、音乐竞技节目精彩不断',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然、历史、人文、科学纪录片，拓展你的视野',
  },
];